/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
import React, {
  useMemo,
  useState,
  useEffect,
  useCallback,
  useImperativeHandle,
  forwardRef
} from 'react';
import { createPortal } from 'react-dom';

import { string, bool, shape } from 'prop-types';

const modalRoot = document.querySelector('#modal-root');

function Modal(
  {
    children,
    position = 'center',
    size = 'medium',
    defaultOpened = false,
    customClass = ''
  },
  ref
) {
  const [isOpen, openModal] = useState(defaultOpened);
  const open = useCallback(() => openModal(true), [openModal]);
  const close = useCallback(() => openModal(false), [openModal]);

  const handleEscape = useCallback(
    (e) => {
      if (e.keyCode === 27) close();
    },
    [close]
  );

  useEffect(() => {
    (function Mount() {
      const modalContent = document.querySelector('.sdp-modal-content');
      if (isOpen) {
        document.addEventListener('keydown', handleEscape, false);
        document.body.classList.add('modal-open');
        modalRoot?.setAttribute('style', 'display:block');
        modalRoot?.classList.add('show');
        modalContent && modalContent.classList.add('opening');
        modalContent && modalContent.classList.remove('closing');
      } else {
        modalContent && modalContent.classList.remove('opening');
        modalContent && modalContent.classList.add('closing');
        modalRoot?.removeAttribute('style');
        document.body.classList.remove('modal-open');
        modalRoot?.classList.remove('show');
      }
    })();
    return () => {
      document.removeEventListener('keydown', handleEscape, false);
      document.body.classList.remove('modal-open');
    };
  }, [handleEscape, isOpen]);

  useImperativeHandle(
    ref,
    () => ({
      open,
      close
    }),
    [close, open]
  );

  const modal = useMemo(
    () => (
      <div
        data-testid="modal-component"
        className={`sdp-modal sdp-modal--${size} sdp-modal--${position} sdp-modal__animate ${customClass}`}
      >
        <div className="sdp-modal-content">{children}</div>
      </div>
    ),
    [children, size, position]
  );

  return !isOpen ? null : createPortal(modal, modalRoot);
}

export default forwardRef(Modal);

Modal.propTypes = {
  children: shape({}).isRequired,
  position: string.isRequired,
  size: string.isRequired,
  customClass: string,
  defaultOpened: bool.isRequired
};

Modal.defaultProps = {
  customClass: ''
};
